var { queTypeConfig } = require("../../../../config/config");
var QuesType = queTypeConfig
let dependentQuestion = false //method to check if ques is dependent on another ques answer
import lodash from 'lodash'


const QuesSkipModal = {
    getData(data) {
        let QuestionIndex = 0 //local index used to loop to desired index ques as per condition
        let QuestionIndexArr = [0] //local array maintain to show the questions with initial index 0
        let discardArr = []// local array maintain to discard the question we dont want to traverse through 
        let maxElseQuesNumber // global variable for max else ques number
        let previousSkipArray = []

        for (let index = 0; index < data.length; index++) {
            let surveyQuesItem = data[index]
            let skipLogicMasterData = surveyQuesItem.skip_logic_master_details
            dependentQuestion = false //re-initialize the dependent valiable to false
            let associationArr = [] //array maintained to get the else & then ques index and its showThenQues boolean value

            //method to show next question on condition
            for (let k in skipLogicMasterData) {
                let skipLogicMasterDataItem = skipLogicMasterData[k]

                let elseQuesId = skipLogicMasterDataItem.in_else_question_id
                let inElseQuesIdIndex = data.findIndex(x => x.in_question_master_id == elseQuesId)

                let thenQuesId = skipLogicMasterDataItem.in_then_question_id
                let inThenQuesIdIndex = data.findIndex(x => x.in_question_master_id == thenQuesId)

                //here skip logic data has parameter in_max_else_question_number which give ques number therefore its index is found to perform functionality
                let maxElseQuesNumberIndex = data.findIndex(x => x.in_question_number == skipLogicMasterDataItem.in_max_else_question_number)
                // maxElseQuesNumber = maxElseQuesNumberIndex
                if (!maxElseQuesNumber) {
                  maxElseQuesNumber = maxElseQuesNumberIndex
                }
                if (maxElseQuesNumberIndex > maxElseQuesNumber) {
                  maxElseQuesNumber = maxElseQuesNumberIndex
                }

                let showElseQues = this.checkSkipRule(skipLogicMasterDataItem.skip_logic_rule, skipLogicMasterDataItem.in_parent_question_id, data, surveyQuesItem.userAnswer)

                associationArr.push({
                    'elseQuesIndex': inElseQuesIdIndex,
                    'thenQuesIndex': inThenQuesIdIndex,
                    'showThenQues': (showElseQues == null ? showElseQues : !showElseQues)
                })
            }

            if (associationArr.length != 0) {
                let obj = {
                    'index': index,
                    'associatArray': associationArr
                }
                previousSkipArray = [...previousSkipArray, obj]
            }

// console.log(surveyQuesItem.st_question_title);
// console.log(associationArr);
// console.log(index == QuestionIndex);
// console.log(QuestionIndexArr.indexOf(index) > -1);

            if (index == QuestionIndex || QuestionIndexArr.indexOf(index) > -1) {
                // console.log('INNNNNNN');
                //if index exists in QuestionIndexArr
                surveyQuesItem.showQues = true

                if (skipLogicMasterData.length != 0) {
                    // console.log('INNNNNNN123');
                    // console.log('==========');
                    //skip logic exists for this particular index question

                    if (associationArr.length == 1) {
                        //if it is a single based skip logic

                        let associationItem = associationArr[0]
                        let showThenQuesValue = associationItem.showThenQues
                        let thenInQuesIndex = associationItem.thenQuesIndex
                        let elseInQuesIndex = associationItem.elseQuesIndex

                        if (showThenQuesValue == true) {
                            //here skip is true for then index question
                            if (thenInQuesIndex != -1) {
                                //here then part is not redirected to end of survey

                                if (elseInQuesIndex == -1) {
                                    //here else part is redirected to end survey

                                    let indexData = []
                                    //here then question is smaller then else question
                                    for (let i = thenInQuesIndex; i < data.length; i++) {
                                        indexData.push(i)
                                    }
                                    QuestionIndexArr = [...QuestionIndexArr, ...indexData]

                                } else {
                                    //here else part is not redirected to end survey but redirected to some question

                                    if (thenInQuesIndex < elseInQuesIndex) {
                                        //here then question index is smaller then else question index
                                        let indexDataArr = []
                                        for (let i = thenInQuesIndex; i <= elseInQuesIndex; i++) {
                                            indexDataArr.push(i)
                                        }
                                        QuestionIndexArr = [...QuestionIndexArr, ...indexDataArr]
                                    } else {
                                        //here then question is greater then else question
                                        QuestionIndexArr.push(thenInQuesIndex)
                                        for (let j = elseInQuesIndex; j < thenInQuesIndex; j++) {
                                            discardArr.push(j)
                                        }
                                    }
                                }

                                //dependent loop question issue solution
                                if (dependentQuestion && index == thenInQuesIndex) {
                                    for (let k = thenInQuesIndex; k < elseInQuesIndex; k++) {
                                        QuestionIndexArr.push(k)
                                    }
                                }

                            } else if (thenInQuesIndex == -1) {
                                //here then part is redirected to end of survey, hence discard those questions
                                for (let k = index; k < data.length; k++) {
                                    discardArr.push(k)
                                }
                            } else {

                            }

                        } else {
                            //here skip is false for then index question
                            if (elseInQuesIndex != -1) {
                                // console.log(1);
                                //here the else ques index is not redirecting to  end survey

                                if (thenInQuesIndex == -1) {
                                    // console.log(2);
                                    let indexDataArray = []
                                    for (let i = elseInQuesIndex; i < data.length; i++) {
                                        indexDataArray.push(i)
                                    }
                                    QuestionIndexArr = [...QuestionIndexArr, ...indexDataArray]
                                } else {
                                    // console.log(3);
                                    if (elseInQuesIndex > thenInQuesIndex) {
                                        console.log(4);
                                        QuestionIndexArr.push(elseInQuesIndex)
                                        for (let i = thenInQuesIndex; i < elseInQuesIndex; i++) {
                                            discardArr.push(i)
                                        }
                                    } else {
                                        // console.log(5);
                                        //here elseInQuesIndex is smaller then thenInQuesIndex
                                        let indexesData = []
                                        for (let i = elseInQuesIndex; i < thenInQuesIndex; i++) {
                                            indexesData.push(i)
                                        }
                                        QuestionIndexArr = [...QuestionIndexArr, ...indexesData]
                                    }
                                }

                                // console.log('dependentQuestion =>', dependentQuestion)
                                if (dependentQuestion && index == thenInQuesIndex) {
                                    // console.log(6);
                                    data[thenInQuesIndex].showQues = false
                                    discardArr.push(thenInQuesIndex)
                                }
                            } else if (elseInQuesIndex == -1) {
                                for (let k = index; k < data.length; k++) {
                                    discardArr.push(k)
                                }
                            } else {

                            }

                        }
                    } else if (associationArr.length > 1) {
                        //if it is batch base skip logic

                        //method to find the highest (max) index from association array
                        const max = associationArr.reduce(function (prev, current) {
                            return (prev.elseQuesIndex > current.elseQuesIndex) ? prev : current
                        })
                        const negativeIndexExists = associationArr.some(el => el.elseQuesIndex == -1)
                        const maxVal = negativeIndexExists ? data.length - 1 : max.elseQuesIndex
                        let modifiedArr = []

                        for (let k in associationArr) {
                            let associationArrItem = associationArr[k]

                            let showThenQuesVal = associationArrItem.showThenQues
                            let thenInQuesIndexVal = (associationArrItem.thenQuesIndex == -1) ? data.length - 1 : associationArrItem.thenQuesIndex
                            let elseInQuesIndexVal = (associationArrItem.elseQuesIndex == -1) ? data.length - 1 : associationArrItem.elseQuesIndex
                            let indexes = []

                            let minNumber = thenInQuesIndexVal < elseInQuesIndexVal ? thenInQuesIndexVal : elseInQuesIndexVal
                            let maxNumber = thenInQuesIndexVal > elseInQuesIndexVal ? thenInQuesIndexVal : elseInQuesIndexVal
                            for (var i = minNumber; i <= maxNumber; i++) {
                                indexes.push(i)
                            }

                            modifiedArr.push({
                                elseIndex: elseInQuesIndexVal,
                                thenIndex: thenInQuesIndexVal,
                                showQues: showThenQuesVal,
                                range: indexes,
                                realThenIndex: associationArrItem.thenQuesIndex,
                                realElseIndex: associationArrItem.elseQuesIndex
                            })

                        }

                        let loopBreak = false

                        let noAnswerSelected = lodash.every(associationArr, ['showThenQues', false])
                        if (noAnswerSelected) {
                            // if no answer is selected put all index in discard
                            let removeIndex = []
                            for (let o in modifiedArr) {
                                removeIndex = [...removeIndex, ...modifiedArr[o].range]
                            }
                            removeIndex = [...new Set(removeIndex)]
                            discardArr = [...discardArr, ...removeIndex]
                        } else {
                            //if one or more then answer are true
                            for (let v in modifiedArr) {
                                let item = modifiedArr[v]
                                let showQuesThen = item.showQues

                                if (showQuesThen) {
                                    if (item.realThenIndex == -1) {
                                        let allIndex = []
                                        for (let w = index + 1; w < data.length; w++) {
                                            allIndex.push(w)
                                        }
                                        discardArr = [...discardArr, ...allIndex]

                                        let difference2 = QuestionIndexArr.filter(x => !allIndex.includes(x))
                                        QuestionIndexArr = difference2
                                        loopBreak = true
                                        break
                                    } else {

                                        QuestionIndexArr = [...new Set([...QuestionIndexArr, ...item.range])]

                                        //remove else ques from quesindex array and add in discard array
                                        //realElseIndex == -1
                                        //realElseIndex > -1
                                        let elseAndNextThenAreSame = (v != modifiedArr.length - 1) ? (item.realElseIndex == modifiedArr[parseInt(v) + 1].realThenIndex) : false

                                        if (elseAndNextThenAreSame) {
                                            //if true then only remove else index
                                            let elseQuesInQuesArrIndex = QuestionIndexArr.indexOf(item.realElseIndex)
                                            if (elseQuesInQuesArrIndex > -1) {
                                                QuestionIndexArr.splice(elseQuesInQuesArrIndex, 1)
                                            }
                                            discardArr = [...discardArr, item.realElseIndex]
                                        }

                                        let thenQuesInDisArrIndex = discardArr.indexOf(item.realThenIndex)
                                        if (thenQuesInDisArrIndex > -1) {
                                            discardArr.splice(thenQuesInDisArrIndex, 1)
                                        }
                                    }
                                } else {
                                    discardArr = [...new Set([...discardArr, ...item.range])]
                                }
                            }
                        }

                        /******* */

                        if (!loopBreak) {
                            let checkMaxElseInPreSkip = this.checkMaxElseInPreviousSkips(previousSkipArray, index, maxVal)

                            if (checkMaxElseInPreSkip) {
                                //hide highest else question if already hidden on previous skip logic
                                let discardIndexArr = []
                                for (let p = maxVal + 1; p < maxElseQuesNumber; p++) {
                                    discardIndexArr.push(p)
                                }
                                discardArr = [...discardArr, ...discardIndexArr]

                                let difference2 = QuestionIndexArr.filter(x => !discardIndexArr.includes(x))
                                QuestionIndexArr = difference2
                            } else {
                                //display ques after highest else question
                                let displayIndex = []
                                for (let p = maxVal; p < data.length; p++) {
                                    displayIndex.push(p)
                                }
                                QuestionIndexArr = [...QuestionIndexArr, ...displayIndex]

                                let difference1 = discardArr.filter(x => !displayIndex.includes(x))
                                discardArr = difference1
                            }
                        }

                        /***** */
                    } else {

                    }

                    //method to remove duplicates
                    QuestionIndexArr = [...new Set(QuestionIndexArr)]
                    discardArr = [...new Set(discardArr)]

                    //method to find diffence indexes from QuestionIndexArr and  discardArr to display segment under segment questions
                    let difference = QuestionIndexArr.filter(x => !discardArr.includes(x))
                    QuestionIndexArr = difference

                } else {
                    // console.log('OUTTTTTT');
                    //skip logic does not exists for this particular index question

                    // move to next index
                    // does that index exists in QuestionIndexArr
                    //does that index exist in discardArr
                    //does it eqal to maxElseQuesNumber

                    if (QuestionIndexArr[QuestionIndexArr.length - 1] < index + 1) {

                        ///method not to push question index if its in discard array
                        if (discardArr.indexOf(index + 1) == -1) {
                            if (index + 1 <= data.length - 1) {
                                QuestionIndexArr.push(index + 1)
                                QuestionIndexArr = [...new Set(QuestionIndexArr)]
                            }
                        }
                    }
                }

            } else if (index > maxElseQuesNumber && maxElseQuesNumber > -1) {
                //here index is greater then maxElseQuesNumber and maxElseQuesNumber is > 1 that is not directing to end survey
                // to do if maxelsequesNumber is less then maxThenQUestion

                for (let h = maxElseQuesNumber; h < data.length; h++) {
                    if (discardArr.indexOf(h) == -1) {
                        data[h].showQues = true
                    }
                }

                //here increament local index varial to loop to next ques from max else ques
                if (discardArr.indexOf(index) == -1 && index + 1 <= data.length - 1) {
                    QuestionIndex = index + 1
                }
            } else {
                //index does not exists in QuestionIndexArr
            }
        }
        return data
    },

    checkMaxElseInPreviousSkips(previousSkipArr, presentIndex, maxValue) {
        let filteredArr = previousSkipArr.filter((item) => item.index < presentIndex)
        if (filteredArr.length > 0) {
            let arrayToSearch = filteredArr[filteredArr.length - 1].associatArray
            for (let u in arrayToSearch) {
                let newItem = arrayToSearch[u]
                if (newItem.thenQuesIndex == maxValue) {
                    if (!newItem.showThenQues) {
                        return true
                    }
                }
            }
            return false
        } else {
            return false
        }
    },

    checkSkipRule(skipRuleData, parentId, allQuesData, userAnswer) {
        let conditionsMatchArray = [] //array containing true false

        for (let l in skipRuleData) {
            let skipRuleItem = skipRuleData[l]
            let questionType = skipRuleItem.in_question_type_id
            let QuesStIsAnswer = skipRuleItem.st_is_answer
            let QuesStSkiplogicCondition = skipRuleItem.st_skiplogic_condition
            let skipRuleDetail = skipRuleItem.skip_logic_rule_details
            let previousCondition = (l == 0) ? null : skipRuleData[l - 1].st_skiplogic_condition


            let masterIdSkipIsBased = (skipRuleDetail.length != 0) ? skipRuleDetail[0].in_question_master_id : parentId  //get the master id on which rule is applied from its first index only

            if (masterIdSkipIsBased != parentId) {
                dependentQuestion = true
                //masterid is not same as parent id therefore answer of master id question is used to verify conditions
                let masterIdIndex = allQuesData.findIndex(x => x.in_question_master_id == masterIdSkipIsBased)
                let masterQuesAnswer = allQuesData[masterIdIndex].userAnswer
                let masterQuestionType = allQuesData[masterIdIndex].in_question_type_id

                let conditionVerified = this.checkSkipConditions(masterQuesAnswer, masterQuestionType, QuesStIsAnswer, QuesStSkiplogicCondition, skipRuleDetail, conditionsMatchArray, previousCondition)
                conditionsMatchArray = conditionVerified
            } else if (masterIdSkipIsBased == parentId) {
                dependentQuestion = false
                // master id is same as parent id therefore answer of this ques is used
                let conditionVerified = this.checkSkipConditions(userAnswer, questionType, QuesStIsAnswer, QuesStSkiplogicCondition, skipRuleDetail, conditionsMatchArray, previousCondition)
                conditionsMatchArray = conditionVerified
            } else {
                // to do
                dependentQuestion = false
            }
        }

        if (conditionsMatchArray.length != 0) {
            let hasNullValue = conditionsMatchArray.includes(null)
            if (hasNullValue) {
                // when question is not answered
                return null
            } else {
                let hasTrueValue = conditionsMatchArray.includes(true)
                if (hasTrueValue) {
                    //contain true value therefore show then ques, hereby return false
                    return false
                } else {
                    //doesnot contain true value hence else question will be displayed, therefore return true
                    return true
                }
            }
        } else {
            // no data for which condition is matched there show else ques
            return true
        }

    },

    checkSkipConditions(quesAnswer, questionOfType, QuesStIsAnswer, QuesStSkiplogicCondition, skipRuleDetail, conditionsMatchArray, previousCondition) {
        if (questionOfType == QuesType.TYPE_INPUT
            || questionOfType == QuesType.TYPE_EMAIL
            || questionOfType == QuesType.TYPE_CURRENCY
            || questionOfType == QuesType.TYPE_DATE
            || questionOfType == QuesType.TYPE_12_HOURS
            || questionOfType == QuesType.TYPE_NUMBER
            || questionOfType == QuesType.TYPE_TELEPHONE
            || questionOfType == QuesType.TYPE_24_HOURS
            || questionOfType == QuesType.TYPE_CAMERA
            || questionOfType == QuesType.TYPE_QR_AND_BARCODE_READER
            || questionOfType == QuesType.TYPE_SIGNATURE) {

            //skip questions of Answered and Unanswered type only
            if (typeof quesAnswer === 'undefined') {
              quesAnswer = ''
            }
            let answeredVerified = this.checkAnsweredUnanswered(QuesStIsAnswer, QuesStSkiplogicCondition, quesAnswer)
            // push the value and return the condition match array
            conditionsMatchArray.push(answeredVerified)
            return conditionsMatchArray
        } else if (questionOfType == QuesType.TYPE_LIST
            || questionOfType == QuesType.TYPE_YES_NO
            || questionOfType == QuesType.TYPE_MULTIPLE_TEXT
            || questionOfType == QuesType.TYPE_TERMS_AND_CONDITIONS
            || questionOfType == QuesType.TYPE_TRUE_FALSE
            || questionOfType == QuesType.TYPE_OTHER
            || questionOfType == QuesType.TYPE_MULTIPLE_IMAGE
            || questionOfType == QuesType.TYPE_SATISFACTION
            || questionOfType == QuesType.TYPE_STAR) {

            //when skip question are of answered unanswered and condition based

            if (typeof quesAnswer === 'undefined') {
              quesAnswer = ''
            }
            let modifiedUserAnswer = (questionOfType == QuesType.TYPE_MULTIPLE_TEXT || questionOfType == QuesType.TYPE_MULTIPLE_IMAGE) ? quesAnswer : [quesAnswer]
            let answeredVerified = this.checkAnsweredUnAnsweredWithConditions(QuesStIsAnswer, QuesStSkiplogicCondition, modifiedUserAnswer, skipRuleDetail, conditionsMatchArray, previousCondition)

            return answeredVerified
        } else {
            //questions other then the mentioned above
            conditionsMatchArray.push(true)
            return conditionsMatchArray
        }
    },

    //method to check answred unanswered ques without conditions
    checkAnsweredUnanswered(st_is_answer, st_skiplogic_condition, userAnswer) {
        if (st_is_answer == 'ANSWERED' && st_skiplogic_condition == '') {
            // return value true if condition is satisfied, else false
            if (userAnswer.length > 0) {
                return true
            } else {
                return false
            }
        } else if (st_is_answer == 'NOTANSWERED' && st_skiplogic_condition == '') {
            //if answer lenght is 0 then return true, else false
            if (userAnswer.length > 0) {
                return false
            } else {
                return true
            }
        } else {
            //no case, therefore condistion doesnot satisfy so return false
            return false
        }
    },

    //method to check answred unanswered ques with conditions
    checkAnsweredUnAnsweredWithConditions(st_is_answer, st_skiplogic_condition, modifiedUserAnswer, skipRuleDetail, conditionsMatchArray, previousCondition) {
        let answerIsEmpty = (typeof modifiedUserAnswer != 'string') ? ((modifiedUserAnswer.length == 0) ? true : (modifiedUserAnswer[0] == "" ? true : false)) : (modifiedUserAnswer == "" ? true : false)
        if (st_is_answer == 'ANSWERED') {
            if (answerIsEmpty) {
                conditionsMatchArray.push(false)
            } else {
                let skipRuleConditionValue = this.checkInclusionRules(skipRuleDetail, modifiedUserAnswer)
                if (previousCondition == 'AND') {
                    let oldBoolValue = conditionsMatchArray[conditionsMatchArray.length - 1]
                    conditionsMatchArray[conditionsMatchArray.length - 1] = (oldBoolValue && skipRuleConditionValue)
                } else {
                    conditionsMatchArray.push(skipRuleConditionValue)
                }
            }
        } else {
            let notanswerConditionSatify = answerIsEmpty
            if (previousCondition == 'AND') {
                let oldBoolValue = conditionsMatchArray[conditionsMatchArray.length - 1]
                let modifyOldBoolValue = (oldBoolValue == null) ? false : oldBoolValue
                conditionsMatchArray[conditionsMatchArray.length - 1] = (modifyOldBoolValue && notanswerConditionSatify)
            } else {
                conditionsMatchArray.push(notanswerConditionSatify)
            }
        }

        return conditionsMatchArray
    },

    //check conditions for inclusion rule
    checkInclusionRules(ruleDetailData, Answer) {
        // let answerSelected = Answer
        let answerSelected = (Answer == '') ? Answer : (typeof Answer == 'string' ? Answer.split(',') : Answer) ///updated code due to unfinished survey saved answer
        let ruleType = ruleDetailData[0].st_rule_type
        let ruleCondition = ruleDetailData[0].st_logical_condition
        let optionsAvailable = ruleDetailData.map(item => item.st_answer_value === "Other (Not from list)" ? 'other' : item.st_answer_value.toLowerCase())

        if (answerSelected) {
            if (typeof answerSelected === 'object') {
                answerSelected = answerSelected.map(v => typeof v === 'number' ? v.toString() : v.toLowerCase())
            }
            if (ruleType == 'ANY' && ruleCondition == 'EQUALS') {
                //selected answer should be amongst the options available only
                if (typeof answerSelected === 'object') {
                    for (let j in answerSelected) {
                        let item = answerSelected[j]
                        let index = optionsAvailable.indexOf(item)
                        if (index == -1) {
                            return false
                        }
                    }
                    return true
                } else {
                  let index = optionsAvailable.indexOf(answerSelected.toLowerCase())
                  if (index == -1) {
                    return false
                  }
                  return true
                }

                return false
            } else if (ruleType == 'ANY' && ruleCondition == 'CONTAINS') {
                //atleast one element should be selected from option availble 
                let returnVal = answerSelected.some(r => optionsAvailable.includes(r))
                // console.log("Answer ANY CONTAINS++++++", answerSelected.every(val => optionsAvailable.includes(val)))
                return returnVal
            } else if (ruleType == 'ALL' && ruleCondition == 'EQUALS') {
                //selected answer should be exactly the same as option available
                let returnVal = (optionsAvailable.length === answerSelected.length && optionsAvailable.sort().every(function (value, index) { return value === answerSelected.sort()[index] }))
                return returnVal
            } else if (ruleType == 'ALL' && ruleCondition == 'CONTAINS') {
                //selected answer should be all of option available and other answer as well
                let returnVal = optionsAvailable.every(val => answerSelected.includes(val))
                return returnVal
            } else {
                return true
            }
        } else {
            //check this need to be done
            return false
        }
    },
}


export default QuesSkipModal


// WEBPACK FOOTER //
// ./src/assets/js/skipLogic/QuesSkipModal.js